import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { PaymentMode } from "../../../constants";
import Button from "../../common/Button";
import Input from "../../common/Input";
import { handleChatBot } from "../../../utils";
import Select from "../../common/Select";
import CongratsModal from "../../commonComponents/congratsModal";
import FeedBackModal from "../../commonComponents/feedbackModal";
import TermModal from "../../commonComponents/termModal";

const PaymentSetup = (props) => {
  const { openTab } = props

  // className={openTab.includes('Payment Setup')? "tab-pane fade show active" : "tab-pane fade"}
  //     id="pills-PaymentSetup"
  //     role="tabpanel"
  //     aria-labelledby="pills-PaymentSetup-tab"
  return (
    <div class="">

      {/* <div class="containWrap"> */}
        {/* <div class="pageMsg">
          <p>BUILD YOUR PROFILE TO FIND THE RIGHT OPPORTUNITIES <span></span> SHOW THE CUSTOMERS YOU ARE THE ONE THEY WANT
          </p>
        </div> */}
        <form>
          <div class="boxCover pt-4">
            <div class="boxTitle pt-3">
              <div class="row align-items-center">
                <div class="col-6">
                  <h1 class="titleText mb-0">Tell us how you would like to receive your payments</h1>
                </div>
                <div class="col-6 text-end">
                  <button class="button">Do it Later</button>
                  <button class="button button-primary" type="button" data-bs-toggle="modal"
                    data-bs-target="#feedbackModal">Save Details</button>
                </div>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-sm-5">
                <div class="fieldSet border-0 pt-0">
                  <ul>
                    <li class="fullWidth">
                      <div class="fieldWrap mb-3">
                        <label class="labelForm">Preferred Mode of Payment <small
                          class="labelBadge">Private</small></label>
                        <div>
                          <select class="fieldForm">
                            <option>UPI</option>
                          </select>
                        </div>
                      </div>
                    </li>
                    <li class="fullWidth">
                      <div class="fieldWrap mb-3">
                        <label class="labelForm">UPI ID <small class="labelBadge">Private</small></label>
                        <div>
                          <input class="fieldForm" type="text" value="23AAAA00002" />
                        </div>
                      </div>
                    </li>
                    <li class="fullWidth">
                      <small class="smallNote">*You will be able to access the payment modes in the “My Income”
                        section.</small>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-6 text-end">
                <div class="paymentIns mb-3">
                  <div class="paymentIns-icon">i</div>
                  <div class="paymentIns-text px-4 ps-2">
                    <p>TDS is deducted based on current applicable law in India.
                      For more information, read our <a>FAQs</a></p>
                  </div>
                </div>
                <div class="paymentMsg">
                  <h2>Terms and Conditions</h2>
                  <p>Payments will be transferred to your account based on the terms and conditions governing the use of
                    this portal. </p>
                  <small>*You will be able to see all your transactions in the 'My Income' section.</small>
                  <div class="text-center pt-4 pb-4">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#legalModal">Read Terms and Conditions, and Privacy
                      Policy Now</a>
                  </div>
                  <label class="styledCheck"><input type="checkbox" /><span>I have read the Terms and Conditions and
                    Privacy Policy</span></label>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center boxFooter">
            <button class="button">Do it Later</button>
            <button class="button button-primary" type="button" data-bs-toggle="modal"
              data-bs-target="#feedbackModal">Save Details</button>
            <button class="button">MESSAGE FROM THE FOUNDER</button>
          </div>
        </form>
      {/* </div> */}

      <div class="pullUp">
        <b class="icon-arrow-right"></b>
      </div>

      <FeedBackModal />
      <CongratsModal/>
      <TermModal/>


      <div class="quickFAQ" onClick={(e) => handleChatBot(e)}>
        <p>Questions?</p>
        <span>Talk to Us</span>
      </div>




     </div>




  );

};
PaymentSetup.propTypes = {
  openTab: PropTypes.array,
};

PaymentSetup.defaultProps = {
  openTab: [],
};

export default PaymentSetup;
// <div>
    //   <div className="col-lg-12 mb-4 frame p-5 shadow-box">
    //     <p className="mx-3 my-0 text-start">Preferred Mode Of Payment</p>
    //     <div className="row">
    //       <div className="col-lg-6 col-sm-6 p-0">
    //         <Select options={PaymentMode} />
    //       </div>
    //     </div>
    //   <div className="col-lg-12 mb-4">
    //     <p className="mx-3 my-0 text-start">UPI ID</p>
    //     <div className="row align-items-center">
    //       <div className="col-lg-6 col-sm-6 p-0">
    //         <Input
    //           type="text"
    //           placeholder="xyz@okicici"
    //           className="form-control grey-input"
    //           label=""
    //         />
    //       </div>
    //       <div className="col-lg-6 col-sm-6 p-0 text-start">
    //         <div className="ms-2">
    //           <Link to="">Verify</Link>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="text-start mb-5">
    //       <small>
    //         <i>
    //           *Payment will be transferred to your account on the 2nd of every
    //           month. You will be able to view all your transactions from the
    //           "My Income" section
    //         </i>
    //       </small>
    //     </div>
    //     <div>
    //       <span className="me-2">
    //         <Button title="Back" disabled />
    //       </span>
    //       <Button title="Save & Next" />
    //     </div>
    //   </div>
    //   </div>
    // </div>